import React, {useState} from "react";
import {useDispatch} from "react-redux";
import { Button, Checkbox, Control, Field, Input } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";


export default function WorkTypeRow({workTypeData, index, dataFresh, onUpdate}){
    const dispatch = useDispatch();
    const [workType, setWorkType] = useState(workTypeData);
    const [editable, setEditable] = useState(false);

    const onEdit = e => {
        e.stopPropagation();
        setEditable(!editable);
    };
    const handleDelete = e => {
        const conf = {
            method: "delete",
            url: "api/worktype/"+workType.id
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            if(err){
                toast.error("There was an error", {position: "top-right"});
            }
        })
    }
    const onChange = (e) => {
        let newWorkType = {...workType};
        newWorkType[e.target.name] = e.target.value;
        setWorkType(newWorkType);
        onUpdate(index, newWorkType);
    }

    const onCheck = (e) => {
        let toUpdate = {
            target: {
                name : e.target.name,
                value: !workType[e.target.name]
            }
        }
        onChange(toUpdate);
    }
    const submitUpdate = (e) => {
        e.stopPropagation();
        const conf = {
            method: "put",
            data: workType,
            url: "api/worktype/"+workType.id
        }
        axios(conf).then(res => {
           setEditable(false);
           dispatch(createSetDataFreshAction(dataFresh + 1))
        })
    }


    return (
        <tr key={workTypeData.id}>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                            type={"text"}
                            name={"name"}
                            value={workType.name}
                            disabled={!editable}
                            onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                        <Control>
                            <Button color="success" onClick={submitUpdate}>
                                Save
                            </Button>
                        </Control>
                    ) : (
                        <Control>
                            <Button onClick={onEdit}>Edit</Button>
                        </Control>
                    )}
                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()}>
                    <Control>
                        <Checkbox
                            name={"free_of_charge"}
                            checked={workType.free_of_charge}
                            disabled={!editable}
                            onChange={onCheck}
                        />
                    </Control>
                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()}>
                    <Control>
                        <Checkbox
                            name={"approval_needed"}
                            checked={workType.approval_needed}
                            disabled={!editable}
                            onChange={onCheck}
                        />
                    </Control>
                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()}>
                    <Control>
                        <Checkbox
                            name={"warranty_claim"}
                            checked={workType.warranty_claim}
                            disabled={!editable || workType.free_of_charge}
                            onChange={onCheck}
                        />
                    </Control>
                </Field>
            </td>
            <td>
                <Button
                    color={"danger"}
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </td>
        </tr>
    );


}